import React, {useEffect, useState} from 'react'
import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel, DialogTitle,
} from '@headlessui/react'
import {
    AdjustmentsHorizontalIcon,
    ArchiveBoxIcon, ArrowRightStartOnRectangleIcon, BanknotesIcon,
    Bars3Icon, BeakerIcon,
    BookOpenIcon, CakeIcon, CalendarDaysIcon,
    ChartPieIcon,
    CheckBadgeIcon, CheckIcon, ChevronDoubleRightIcon,
    ClipboardDocumentListIcon, ClockIcon, CreditCardIcon,
    CurrencyDollarIcon,
    DocumentCurrencyDollarIcon,
    FolderOpenIcon,
    HomeIcon, IdentificationIcon,
    InboxIcon,
    MapIcon, MoonIcon, PencilIcon, PercentBadgeIcon, PhoneIcon, PlusIcon,
    QuestionMarkCircleIcon,
    RectangleStackIcon, SparklesIcon, SunIcon,
    UserCircleIcon,
    UserGroupIcon, UserPlusIcon as OutlineUserPlusIcon,
    UserPlusIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline'
import logo from "../PFC_Images/main-logo.png";
import {useDarkMode} from "../contexts/darkModeContext";
import {useAuth} from "../contexts/authContext";
import {auth, db} from "../firebase/firebase";
import {doSignOut} from "../firebase/auth";
import FireworksEffect from "./Widgets/FireworksEffect";
import course from "../PFC_Images/course.jpg";
import lyme from "../PFC_Images/lymeTrucks.jpg";
import warehouse from "../PFC_Images/PFCWarehouse.JPG";
import PFC46 from "../PFC_Images/PFC46.png";
import PFCLogo from "../PFC_Images/PFC_Logo_Full.png";
import CyberBackground from "./CyberBackground";
import {onAuthStateChanged} from "firebase/auth";
import {SnowOverlay} from "react-snow-overlay";
import {useNavigate} from "react-router-dom";
import Home from "./Home";
import Dashboard from "./Dashboard";
import Catalog from "./Catalog";
import Proven from "./Proven";
import Profile from "./Profile";
import Soil from "./Soil";
import SalesTeam from "./SalesTeam";
import CustomerMap from "./CustomerMap/CustomerMap";
import Customers from "./Customers";
import Archive from "./Archive";
import Orders from "./Orders";
import PlantOrders from "./PlantOrders";
import PlantCustomers from "./PlantCustomers";
import Guides from "./Guides";
import Pricing from "./Pricing/Pricing";
import NewOrder from "./OrderForm/NewOrder";
import NewCustomer from "./NewCustomer";
import Background from "./Background";
import PlantArchive from "./PlantArchive";
import Loading from "./Widgets/Loading";
import SignUp from "./SignUp";
import Performance from "./Performance";
import Chatbot from "./Chatbot";
import {updateCustomers, updateProducts} from "./GLOBAL/GlobalUpdatingFunctions";

import { ReactComponent as SIDE } from "../customIcons/SideBar.svg";
import { ReactComponent as JUG } from "../customIcons/GalJug.svg";
import { ReactComponent as CSR } from "../customIcons/CSR.svg";
import { ReactComponent as PFC } from "../customIcons/PFC.svg";


// import all the styles
import "react-rain-animation/lib/style.css";
import KissUpload from "./KissUpload";
import DeveloperOrder from "./DeveloperOrder";
import CSRStatus from "./CSRStatus";
import {formatTimeStampDate} from "./GLOBAL/GlobalFunctions";
import WeatherWidget from "./Widgets/WeatherWidget";
import {doc, getDoc, onSnapshot} from "firebase/firestore";
import AnimatedTrailButton from "./Widgets/AnimatedTrailButton";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Content = () => {
    
    const [sidebarOpen, setSidebarOpen] = useState(false);
    // const [collapseSide, setCollapseSide] = useState(false);
    const [chat, setChat] = useState(false);
    
    const [collapseSide, setCollapseSide] = useState(() => {
        const savedState = localStorage.getItem('collapseState');
        return savedState === null ? false : JSON.parse(savedState);
    });

    const toggleCollapseSide = () => {
        setCollapseSide(prevCollapse => {
            const newCollapse = !prevCollapse;
            localStorage.setItem('collapseState', JSON.stringify(newCollapse));
            return newCollapse;
        });
    };
    
    const navigate = useNavigate();
  
    const { darkMode, toggleDarkMode } = useDarkMode();

    const { currentUser } = useAuth();
    
    const navigation = [
        { name: "Home", icon: HomeIcon, visibleTo: ["D", "CSR", "A", "S", "DIST", "PFC"], disabled: false },
        { name: "Personal Dashboard", icon: ChartPieIcon, visibleTo: ["D", "A", "S", "DIST", "PFC"], disabled: false },
        { name: "Catalog", icon: BookOpenIcon, visibleTo: ["D", "CSR", "A", "S", "DIST", "PFC"], disabled: true },
        { name: "Proven Programs", icon: CheckBadgeIcon, visibleTo: ["D", "CSR", "A", "S", "DIST", "PFC"], disabled: true },
        { name: "Profile & Settings", icon: UserCircleIcon, visibleTo: ["D", "CSR", "A", "S", "DIST", "PFC"], disabled: false },
        
        { name: "Current Orders", icon: ClipboardDocumentListIcon, visibleTo: ["D", "A", "S", "DIST"], disabled: false },
        { name: "Archived Orders", icon: ArchiveBoxIcon, visibleTo: ["D", "A", "S", "DIST"], disabled: false },
        { name: "Customer Management", icon: FolderOpenIcon, visibleTo: ["D", "A", "S", "DIST"], disabled: false },
        { name: "Customer Map", icon: MapIcon, visibleTo: ["D", "A", "S"], disabled: false },
        { name: "Sales Tool Users", icon: UserGroupIcon, visibleTo: ["D", "A", "S"], disabled: true },
        { name: "Soil Test Results", icon: BeakerIcon, visibleTo: ["D", "A", "S"], disabled: true },
        
        { name: "Help & Resources", icon: QuestionMarkCircleIcon, visibleTo: ["D", "CSR", "A", "S", "DIST", "PFC"], disabled: true },
        // { name: "Program Builder", icon: WrenchScrewdriverIcon, visibleTo: ["D", "A", "S", "DIST"], disabled: true },
        { name: "Product Pricing", icon: DocumentCurrencyDollarIcon, visibleTo: ["D", "A"], disabled: false },
        { name: "User Onboard", icon: IdentificationIcon, visibleTo: ["D"], disabled: false },
        { name: "CSR Performance", icon: PercentBadgeIcon, visibleTo: ["D"], disabled: false },
        
        { name: "Rep Orders", icon: InboxIcon, visibleTo: ["D", "A", "CSR", "PFC"], disabled: false },
        { name: "Rep Customers", icon: UserPlusIcon, visibleTo: ["D", "A", "CSR", "PFC"], disabled: false },
        { name: "Rep Archive Orders", icon: ArchiveBoxIcon, visibleTo: ["D", "A", "CSR", "PFC"], disabled: false },
        { name: "CSR Status", icon: CSR, visibleTo: ["D", "CSR", "A", "S", "PFC"], disabled: false },
       
        { name: "Kiss Upload", icon: RectangleStackIcon, visibleTo: ["D"], disabled: false },
    ]
    
    const [fname, setFname] = useState("");
    const [time, setTime] = useState('');
    const [date, setDate] = useState('');
    
    const [birthDate, setBirthDate] = useState('');
    
    const [alertsOn] = useState(() => {
        const storedSettings = localStorage.getItem('alertsOn');
        return storedSettings ? JSON.parse(storedSettings).alertsOn : false; // Default to false if null
    });

    const [accountLevel, setAccountLevel] = useState("");

    const [profileImage, setProfileImage] = useState('');

    
    const [isLogOut, setIsLogOut] = useState(false);
    
    
    const [city, setCity] = useState("Cranbury");
    const [state, setState] = useState("NJ");


    useEffect(() => {
        const fetchUserName = async () => {
            if (currentUser) {
                try {
                    // Check if user data is in localStorage
                    const storedUserData = localStorage.getItem(`userData_${currentUser.uid}`);

                    if (storedUserData) {
                        // Use the stored user data
                        const userData = JSON.parse(storedUserData);
                        setFname(userData.fname);
                        setProfileImage(userData.profileImageUrl);
                        setAccountLevel(userData.accountLevel);
                        
                        setCity(userData.city || "Cranbury");
                        setState(userData.state || "NJ");
                        
                        // setBirthDate(userData.birthDate);
                    } else {
                        // Fetch user document from Firestore based on the current user's UID
                        const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                        if (userDoc.exists) {
                            // Get the user's name from the document data
                            const userData = userDoc.data();
                            setFname(userData.fname);
                            setProfileImage(userData.profileImageUrl);
                            setAccountLevel(userData.accountLevel);
                            
                            setCity(userData.city || "Cranbury");
                            setState(userData.state || "NJ");
                            
                            // setBirthDate(userData.birthDate);

                            // Save user data to localStorage
                            localStorage.setItem(`userData_${currentUser.uid}`, JSON.stringify(userData));
                        } else {
                            console.log('User document not found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };
        
        const fetchBirthDate = async () => {
            if (currentUser) {
                try {
                    // Fetch user document from Firestore based on the current user's UID
                    const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                    if (userDoc.exists) {
                        // Get the user's name from the document data
                        const userData = userDoc.data();
                        setBirthDate(userData.birthDate || "");
                    } else {
                        console.log('User document not found');
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };

        fetchUserName();
        fetchBirthDate();
    }, [currentUser]);


    useEffect(() => {
        const fetchWeather = async () => {
            // Get current time (hours and minutes only)
            const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            setTime(currentTime);

            // Get current date
            const currentDate = new Date().toLocaleDateString();
            setDate(currentDate);
        };

        fetchWeather();

        // Update time every minute to avoid unnecessary updates every second
        const interval = setInterval(() => {
            const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            setTime(currentTime);
        }, 60000); // Update every minute

        return () => clearInterval(interval);
    }, []);
    
    const [open, setOpen] = useState(false);
    const toggleOpen = () => {
        setOpen(!open);
    };
    
    const [cake, setCake] = useState(false);
    const [Happy, setHappy] = useState(false);
    
    
    
    
    
    
    
    
    
    
    
    const [customerCount, setCustomerCount] = useState(0);

    useEffect(() => {
      const docRef = doc(db, "GlobalSettings", "NewCustomers");
    
      const unsubscribe = onSnapshot(docRef, (snap) => {
        if (snap.exists()) {
          setCustomerCount(snap.data().count || 0);
        } else {
          setCustomerCount(0);
        }
      });
    
      return () => unsubscribe(); // cleanup when component unmounts
    }, []);
    
    
    
    
    
    
    
    
    
    const backgroundElements = [
        { Lyman: course },
        { LymeTrucks: lyme },
        { Warehouse: warehouse },
        { CyberBackground: <CyberBackground /> }, // Custom component
    ];

    // State to track the current index and content
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentKey, setCurrentKey] = useState(Object.keys(backgroundElements[0])[0]);
    const [currentContent, setCurrentContent] = useState(Object.values(backgroundElements[0])[0]);

    // Load saved content from local storage on component mount
    useEffect(() => {
        const savedContent = localStorage.getItem("savedContent");
        const savedKey = localStorage.getItem("savedKey");

        if (savedContent && savedKey) {
            // setCurrentContent(JSON.parse(savedContent)); // Parse the saved component
            setCurrentKey(savedKey);
            
            const foundElement = backgroundElements.find((item) => item[savedKey]);
            if (foundElement) {
                setCurrentContent(foundElement[savedKey]);
            }

            const index = backgroundElements.findIndex((item) => Object.values(item)[0] === JSON.parse(savedContent));
            if (index !== -1) setCurrentIndex(index);
        }
            // eslint-disable-next-line
    }, []);

    // Function to handle cycling through images and components
    const handleContentClick = () => {
        const nextIndex = (currentIndex + 1) % backgroundElements.length;
        const nextKey = Object.keys(backgroundElements[nextIndex])[0];
        const nextContent = Object.values(backgroundElements[nextIndex])[0];

        setCurrentIndex(nextIndex);
        setCurrentKey(nextKey);
        setCurrentContent(nextContent);
    };

    // Function to save the current content (image or component) to local storage
    const handleSaveContent = () => {
        localStorage.setItem("savedKey", currentKey);
        if (alertsOn) {
            alert(`Saved ${currentKey} to local storage.`);
        }
    };
    
    // Initialize state with a default value of `false`, but use the value from local storage if it exists
    const [snowing, setSnowing] = useState(() => {
        const savedState = localStorage.getItem('snowing');
        return savedState === 'false'; // Convert string to boolean
    });

    // Function to toggle the snowing state
    const toggleSnow = () => {
        setSnowing((prev) => {
            const newState = !prev;
            localStorage.setItem('snowing', newState); // Save updated state to local storage
            return newState;
        });
    };

    // Ensure local storage value is synced when the component mounts
    useEffect(() => {
        const savedState = localStorage.getItem('snowing');
        if (savedState) {
            setSnowing(savedState === 'true'); // Convert string to boolean
        }
    }, []);
    
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user && window.location.pathname !== "/NewCustomer") {
                navigate("/"); // Redirect to "/" if not authenticated and not on /NewCustomer
            }
        });
    
        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [navigate]);
    
    
    // Store modal state in localStorage
    useEffect(() => {
      const today = new Date();
      const todayMonth = today.getMonth(); // 0-indexed
      const todayDay = today.getDate();
    
      // eslint-disable-next-line
      const [year, month, day] = birthDate.split('-').map(Number);
      const birthMonth = month - 1;
      const birthDay = day;
    
      // Check if it's the user's birthday
      if (todayMonth === birthMonth && todayDay === birthDay) {
        setCake(true);
    
        // Check localStorage for modal dismissal
        const dismissedDate = localStorage.getItem('birthdayModalDismissed');
    
        const todayKey = `${today.getFullYear()}-${todayMonth + 1}-${todayDay}`;
        if (dismissedDate !== todayKey) {
          setHappy(true);
        }
      }
    }, [birthDate]);
    
    // Function to dismiss modal
    const dismissBirthdayModal = () => {
      const today = new Date();
      const todayKey = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      localStorage.setItem('birthdayModalDismissed', todayKey);
      setHappy(false);
    };
    
    
    
    const [collapse, setCollapse] = useState(true);
    const [collapseSpin, setCollapseSpin] = useState(false);

    const [collapseCustomer, setCollapseCustomer] = useState(true);
    const [collapseSpinCustomer, setCollapseSpinCustomer] = useState(false);

    const [collapseDeveloper, setCollapseDeveloper] = useState(true);
    const [collapseSpinDeveloper, setCollapseSpinDeveloper] = useState(false);


    // Timeout reference to clear it when necessary
    let collapseTimeout;
    let collaspeTimeoutCustomer;
    let collapseTimeoutDeveloper;

    const handleMouseEnter = () => {
        clearTimeout(collapseTimeout); // Clear any existing timeout to prevent premature collapsing
        setCollapse(false); // Expand immediately on hover
    };

    const handleMouseLeave = () => {
        // Set a delay before collapsing again
        setCollapseSpin(true)
        collapseTimeout = setTimeout(() => {
            setCollapse(true); // Collapse after a delay
        }, 500); // Adjust the timeout duration as needed (300ms)

        collapseTimeout = setTimeout(() => {
            setCollapseSpin(false);
        }, 1000); // Adjust the timeout duration as needed (300ms)
    };

    const handleMouseEnterCustomer = () => {
        clearTimeout(collaspeTimeoutCustomer); // Clear any existing timeout to prevent premature collapsing
        setCollapseCustomer(false); // Expand immediately on hover
    };

    const handleMouseLeaveCustomer = () => {
        // Set a delay before collapsing again
        setCollapseSpinCustomer(true);
        collaspeTimeoutCustomer = setTimeout(() => {
            setCollapseCustomer(true); // Collapse after a delay
        }, 500); // Adjust the timeout duration as needed (300ms)

        collapseTimeout = setTimeout(() => {
            setCollapseSpinCustomer(false);
        }, 1000); // Adjust the timeout duration as needed (300ms)
    };
    
    
    
    
    
    const handleMouseEnterDeveloper = () => {
        clearTimeout(collapseTimeoutDeveloper); // Clear any existing timeout to prevent premature collapsing
        setCollapseDeveloper(false); // Expand immediately on hover
    };

    const handleMouseLeaveDeveloper = () => {
        // Set a delay before collapsing again
        setCollapseSpinDeveloper(true);
        collapseTimeoutDeveloper = setTimeout(() => {
            setCollapseDeveloper(true); // Collapse after a delay
        }, 500); // Adjust the timeout duration as needed (300ms)

        collapseTimeout = setTimeout(() => {
            setCollapseSpinDeveloper(false);
        }, 1000); // Adjust the timeout duration as needed (300ms)
    };

    
    
    // const [selectedNav, setSelectedNav] = useState('Home');
    
    const [selectedNav, setSelectedNav] = useState(() => {
        // Load from localStorage on initial render
        return localStorage.getItem(`selectedNav_${currentUser.uid}`) || 'Home';
    });
    
    useEffect(() => {
        // Save to localStorage whenever selectedNav changes
        localStorage.setItem(`selectedNav_${currentUser.uid}`, selectedNav);
        // eslint-disable-next-line
    }, [selectedNav]);
    
    const section1 = navigation.slice(0, 5); // Adjust indexes based on your layout
    const section2 = navigation.slice(5, 11);
    const section3 = navigation.slice(15, 19);
    const section4 = navigation.slice(11, 15);
    const section5 = navigation.slice(19, 20);
    
    const renderNavItems = (section, drawer) =>
        section.map((item) => {
            const isSelected = item.name === selectedNav;
            const isDisabled = item.disabled;
            
            if (!item.visibleTo.includes(accountLevel)) return null;
            
            const animate = item.name === 'Rep Customers' && customerCount !== 0;
    
            return (
                <li key={item.name} className={`${isDisabled ? 'hidden' : ''}`}>
                    <Button
                        disabled={isDisabled}
                        onClick={() => setSelectedNav(item.name)}
                        className={classNames(
                            isSelected
                                ? 'bg-green-600/20 text-green-600 rounded-r-md border-l-2 border-l-green-600'
                                : `${isDisabled ? '' : `hover:bg-green-600/30 hover:text-green-600 rounded-r-md hover:border-l-2 hover:border-l-green-600`}`,
                            'group w-full flex items-center gap-x-3 px-1 py-2 text-sm/6',
                        )}
                    >
                        <item.icon
                            aria-hidden="true"
                            className={classNames(
                                isSelected
                                    ? `${darkMode ? 'text-white' : 'text-black'} animate-epicReveal`
                                    : `${isDisabled ? 'text-gray-500' : `text-green-600 ${darkMode ? 'group-hover:text-white' : 'group-hover:text-black'} group-hover:animate-twistLiftDrop`}`,
                                `size-6 shrink-0 ${animate ? 'animate-flash' : ''}`,
                            )}
                        />
                        <span className={` line-clamp-1 ${darkMode ? 'text-white' : 'text-black'} text-xs`}>
                            {item.name}
                        </span>
                    </Button>
                </li>
            );
        });
        
    
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user && window.location.pathname !== "/NewCustomer") {
                navigate("/"); // Redirect to "/" if not authenticated and not on /NewCustomer
            }
        });
    
        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [navigate]);
   
    const [updating, setUpdating] = useState(false);
    
    
    return (
        <>
            <SnowOverlay
                speed={"FASTER"}
                disabled={snowing}
            />
            
            
            {updating && (
                <Loading/>
            )}
            
            <div className={`${darkMode ? 'text-white bg-darkBgColor' : 'text-black bg-bgColor'}`}>
                
                <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
                    <DialogBackdrop
                        transition
                        className="fixed inset-0 bg-gray-500/20 transition-opacity duration-300 ease-linear data-closed:opacity-0"
                    />
                    
                    <div className="fixed inset-0 flex">
                        <DialogPanel
                            transition
                            className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full"
                        >
                            
                            {/* Sidebar component, swap this element with another sidebar if you like */}
                            <div
                                className={`flex grow flex-col gap-y-5 overflow-y-auto scrollbar-hide ${darkMode ? 'bg-darkMainColor text-white' : 'bg-white text-black'} px-6 pb-4`}>
                                <div className="flex h-16 shrink-0 items-center mt-5">
                                    <img
                                        alt="Your Company"
                                        src={PFC46}
                                        className="h-16 w-auto"
                                    />
                                
                                
                                </div>
                                <nav className="flex flex-1 flex-col">
                                    <ul className="-mx-2 space-y-3">
                                        
                                        {/*Main*/}
                                        <div className={`relative text-xs text-center my-3`}>
                                            <div className={`absolute inset-0 flex items-center justify-center`}>
                                                <div
                                                    className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Main
                                                </div>
                                            </div>
                                            <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                        </div>
                                        <div className={`space-y-0.5`}>{renderNavItems(section1)}</div>
                                        
                                        {/*Data*/}
                                        {["D", "A", "S", "DIST"].includes(accountLevel) && (
                                            <div className={`relative text-xs text-center my-3`}>
                                                <div className={`absolute inset-0 flex items-center justify-center`}>
                                                    <div
                                                        className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Data
                                                    </div>
                                                </div>
                                                <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                            </div>
                                        )}
                                        <div className={`space-y-0.5`}>{renderNavItems(section2)}</div>
                                        
                                        {/*Plant*/}
                                        {["D", "PFC", "CSR"].includes(accountLevel) && (
                                            <div className={`relative text-xs text-center my-3`}>
                                                <div className={`absolute inset-0 flex items-center justify-center`}>
                                                    <div
                                                        className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Plant
                                                    </div>
                                                </div>
                                                <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                            </div>
                                        )}
                                        <div className={`space-y-0.5`}>{renderNavItems(section3)}</div>
                                        
                                        {/*Tools*/}
                                        <div className={`relative text-xs text-center my-3`}>
                                            <div className={`absolute inset-0 flex items-center justify-center`}>
                                                <div
                                                    className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Tools
                                                </div>
                                            </div>
                                            <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                        </div>
                                        <div className={`space-y-0.5`}>{renderNavItems(section4)}</div>
                                        
                                        {/*Soil*/}
                                        {["D"].includes(accountLevel) && (
                                            <div className={`relative text-xs text-center my-3`}>
                                                <div className={`absolute inset-0 flex items-center justify-center`}>
                                                    <div
                                                        className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Soil
                                                    </div>
                                                </div>
                                                <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                            </div>
                                        )}
                                        <div className={`space-y-0.5`}>{renderNavItems(section5)}</div>
                                    
                                    </ul>
                                </nav>
                            </div>
                        </DialogPanel>
                    </div>
                </Dialog>
                
                
                {/* Static sidebar for desktop */}
                <div className={`hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex animate-slideInLeft ${collapseSide ? 'lg:w-14' : 'lg:w-52'} transition-all duration-1000 lg:flex-col`}>
                    {/* Sidebar component, swap this element with another sidebar if you like */}
                    <div
                        className={`flex grow flex-col gap-y-2 scrollbar-hide border-r ${darkMode ? 'bg-darkMainColor border-neutral-700' : 'bg-white'}`}>
                        <div className="flex h-16 sticky shrink-0 items-center">
                            
                            <Button
                                className={`w-full h-full flex items-center justify-center transition-all duration-1000`}
                                onClick={toggleCollapseSide}
                            >
                                <img
                                    alt="Your Company"
                                    src={collapseSide ? PFC46 : PFCLogo}
                                    className={`${collapseSide ? 'size-12' : 'h-14'} transition-all duration-1000`}
                                />
                                {/*<PFC className={`size-8 text-green-600`}/>*/}
                            </Button>
                        
                        </div>
                        <nav className="flex flex-1 flex-col px-4 pb-4 max-h-[calc(100dvh-4rem)] scrollbar-hide overflow-y-auto">
                            
                            
                            <ul className="-mx-1.5 space-y-3">
                                
                                {/*Main*/}
                                <div className={`relative text-xs text-center my-3`}>
                                    <div className={`absolute inset-0 flex items-center justify-center`}>
                                        <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Main</div>
                                    </div>
                                    <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                </div>
                                <div className={`space-y-0.5`}>{renderNavItems(section1)}</div>
                                
                                {/*Data*/}
                                {["D", "A", "S", "DIST"].includes(accountLevel) && (
                                    <div className={`relative text-xs text-center my-3`}>
                                        <div className={`absolute inset-0 flex items-center justify-center`}>
                                            <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Data</div>
                                        </div>
                                        <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                    </div>
                                )}
                                <div className={`space-y-0.5`}>{renderNavItems(section2)}</div>
                                
                                {/*Plant*/}
                                {["D", "PFC", "CSR", "S"].includes(accountLevel) && (
                                    <div className={`relative text-xs text-center my-3`}>
                                        <div className={`absolute inset-0 flex items-center justify-center`}>
                                            <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Plant</div>
                                        </div>
                                        <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                    </div>
                                )}
                                <div className={`space-y-0.5`}>{renderNavItems(section3)}</div>
                                
                                {/*Tools*/}
                                <div className={`relative text-xs text-center my-3`}>
                                    <div className={`absolute inset-0 flex items-center justify-center`}>
                                        <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Tools</div>
                                    </div>
                                    <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                </div>
                                <div className={`space-y-0.5`}>{renderNavItems(section4)}</div>
                                
                                {/*Soil*/}
                                {["D"].includes(accountLevel) && (
                                    <div className={`relative text-xs text-center my-3`}>
                                        <div className={`absolute inset-0 flex items-center justify-center`}>
                                            <div className={`${darkMode ? 'bg-darkMainColor' : 'bg-white'} ${collapseSide ? 'px-0.5' : 'px-2'} tracking-wider text-small`}>Soil</div>
                                        </div>
                                        <div className={`bg-green-600 w-full rounded-full h-0.5`}></div>
                                    </div>
                                )}
                                <div className={`space-y-0.5`}>{renderNavItems(section5)}</div>
                            
                            </ul>
                        
                        
                        </nav>
                    </div>
                </div>
                
                
                {/*Body*/}
                <div className={`${collapseSide ? 'lg:pl-14' : 'lg:pl-52'} transition-all duration-1000`}>
                    
                    {/*Header*/}
                    <div className={`sticky top-0 z-40 flex h-14 shrink-0 animate-slideInTop items-center gap-x-3 border-b ${darkMode ? 'bg-darkMainColor border-neutral-700' : 'bg-white'} pr-4 shadow-xs`}>
                        <Button type="button" onClick={() => setSidebarOpen(true)} className="-m-2.5 p-2.5 text-gray-500 lg:hidden">
                            <span className="sr-only">Open sidebar</span>
                            <Bars3Icon aria-hidden="true" className="size-6"/>
                        </Button>
                        
                        {/*Weather Section*/}
                        <WeatherWidget />
                        
                        {/*Link Section*/}
                        <div className={`flex w-fit space-x-3`}>
                            {["D", "A", "S", "DIST"].includes(accountLevel) && (
                                <>
                                    <AnimatedTrailButton
                                        label="Customer Form"
                                        onClick={() => setSelectedNav('New Customer')}
                                        icon={OutlineUserPlusIcon}
                                    />
                                </>
                            )}
                            
                            {["D", "A", "S", "DIST"].includes(accountLevel) && (
                                <>
                                    <AnimatedTrailButton
                                        label="Order Form"
                                        onClick={() => setSelectedNav('New Order')}
                                        icon={PlusIcon}
                                    />
                                </>
                            )}
                            
                            <div className={`flex items-center gap-x-2 italic`}>
                                
                                {/*Logo Section*/}
                                <div className={`flex items-center text-xs gap-x-1`}>
                                    <PFC className={`size-5 text-green-600`}/>
                                    <span className={``}>PlantFood Sales Tool</span>
                                </div>
                                <span className={`text-gray-500`}>/</span>
                                <span className={`text-xs text-gray-500`}>{selectedNav}</span>
                            
                            </div>
                        
                        </div>
                        
                        {/* Separator */}
                        <div aria-hidden="true" className="h-6 w-px bg-gray-500 lg:hidden"/>
                        
                        {/*Profile Section*/}
                        <div className="flex justify-end w-full flex-1 gap-x-4 self-stretch">
                            
                            <div className="flex items-center gap-x-4">
                                <Button onClick={() => setChat(true)}
                                        className="hidden -m-2.5 p-2.5 text-gray-500 hover:text-green-600 flex items-center">
                                    <SparklesIcon aria-hidden="true" className="size-5 mr-1"/>
                                </Button>
                                
                                {/* Profile */}
                                <div className={`ml-auto drop-shadow ${darkMode ? '' : 'border-black border-1'} hover:scale-105`}>
                                    
                                    {/* Display profile image if available, otherwise show placeholder */}
                                    {profileImage ? (
                                        <div
                                            className={`rounded-full bg-bgColor hover:animate-rubberBand justify-center items-center text-center w-9 h-9`}>
                                            <a
                                                href={`/Profile`}
                                            >
                                                <img
                                                    src={profileImage}
                                                    alt="Profile"
                                                    className="w-full h-full object-cover rounded-lg"
                                                />
                                            </a>
                                        </div>
                                    ) : (
                                        <div
                                            className={`rounded-lg flex ${darkMode ? 'bg-white/5 text-white' : 'bg-black/5 text-black'} hover:animate-rubberBand justify-center items-center text-center w-10 h-10`}>
                                            <a href={`/Profile`}>
                                                <img
                                                    src={logo}
                                                    alt="Profile"
                                                    className="w-6 object-cover"
                                                />
                                            </a>
                                            {/*<UserCircleIcon className="stroke-1"/>*/}
                                        </div>
                                    )}
                                
                                </div>
                                
                                <CakeIcon onClick={() => setHappy(true)} className={`visible ${darkMode ? 'text-white' : 'text-black'} ${cake ? 'visible animate-heartBeatSlow' : 'hidden'} size-6`}/>
                                
                                <div className={`flex flex-col w-fit ${darkMode ? 'text-white' : 'text-black'}`}>
                                    <span className={`text-sm`}>{fname}</span>
                                    <span className={`opacity-50 -mt-1.5 italic text-xs`}>Plant Food Company Inc.</span>
                                </div>
                                
                                <Button
                                    className="flex text-center justify-center items-center text-sm hover:text-opacity-50 hover:scale-105 text-green-600 rounded-md"
                                    onClick={toggleOpen}
                                >
                                    <AdjustmentsHorizontalIcon className={`w-6`}/>
                                </Button>
                                
                                
                                <Button
                                    className="flex text-center justify-center items-center text-sm hover:text-opacity-50 hover:scale-105 text-red-500 rounded-md"
                                    onClick={() => setIsLogOut(true)}
                                >
                                    <ArrowRightStartOnRectangleIcon className={`w-6`}/>
                                </Button>
                            
                            </div>
                        
                        </div>
                    
                    </div>
                    
                    {/*Content*/}
                    <main className={`h-dvh overflow-y-auto animate-fadeIn shadow-inner ${darkMode ? 'bg-darkBgColor' : 'bg-bgColor'}`}>
                        
                        {/*<Background/>*/}
                        
                        <div className="h-full">
                            
                            {selectedNav === 'Home' && <Home/>}
                            {selectedNav === 'Personal Dashboard' && <Dashboard/>}
                            {selectedNav === 'Catalog' && <Catalog/>}
                            {selectedNav === 'Proven Programs' && <Proven/>}
                            {selectedNav === 'Profile & Settings' && <Profile/>}
                            
                            
                            {selectedNav === 'Current Orders' && <Orders/>}
                            {selectedNav === 'Archived Orders' && <Archive/>}
                            {selectedNav === 'Customer Management' && <Customers/>}
                            {selectedNav === 'Customer Map' && <CustomerMap/>}
                            {selectedNav === 'Sales Tool Users' && <SalesTeam/>}
                            {selectedNav === 'Soil Test Results' && <Soil/>}
                            
                            
                            {selectedNav === 'Rep Orders' && <PlantOrders/>}
                            {selectedNav === 'Rep Customers' && <PlantCustomers/>}
                            {selectedNav === 'Rep Archive Orders' && <PlantArchive/>}
                            {selectedNav === 'CSR Status' && <CSRStatus/>}
                            
                            
                            {selectedNav === 'Help & Resources' && <Guides/>}
                            {/*{selectedNav === 'Program Builder' && <Guides/>}*/}
                            {/*{selectedNav === 'Support Tickets' && <Tickets/>}*/}
                            {selectedNav === 'Product Pricing' && <Pricing/>}
                            {selectedNav === 'User Onboard' && <SignUp/>}
                            {selectedNav === 'CSR Performance' && <Performance/>}
                            {/*{selectedNav === 'Messaging' && <Guides/>}*/}
                            
                            
                            {selectedNav === 'Kiss Upload' && <KissUpload/>}
                            
                            
                            {selectedNav === 'New Order' && <NewOrder/>}
                            {selectedNav === 'Developer Order' && <DeveloperOrder/>}
                            {selectedNav === 'New Customer' && <NewCustomer/>}
                        
                        </div>
                    
                    
                    </main>
                
                
                </div>
            
            
            </div>
            
            
            <Dialog open={open} onClose={setOpen} className={`relative z-50 ${darkMode ? 'text-white' : 'text-black'}`}>
                
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/20 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
                />
                
                <div className="fixed inset-0 overflow-hidden font-mono">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full h-full pl-10">
                            <DialogPanel
                                transition
                                className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                            >
                                <div
                                    className={`flex flex-col h-full overflow-y-auto scrollbar-hide ${darkMode ? 'bg-darkMainColor' : 'bg-white'} py-6 shadow-2xl`}>
                                    <div className={`px-4 sm:px-6`}>
                                        <div className="flex items-start justify-between">
                                            <DialogTitle className="text-base font-semibold">Quick
                                                Preferences</DialogTitle>
                                            <div className="ml-3 flex h-7 items-center">
                                                <Button
                                                    type="button"
                                                    onClick={() => setOpen(false)}
                                                    className="relative z-50 rounded-md text-gray-500 hover:text-opacity-50 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                                >
                                                    <span className="absolute -inset-2.5"/>
                                                    <span className="sr-only">Close panel</span>
                                                    <ChevronDoubleRightIcon aria-hidden="true" className="size-6"/>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                    {/*Body*/}
                                    <div className="relative mt-6 flex-1 px-4 sm:px-6 flex-col space-y-12">
                                        
                                        <div className="h-full overflow-y-auto scrollbar-hide">
                                            <div className="space-y-6 relative">
                                                <div>
                                                    {/*<img*/}
                                                    {/*    alt="Cycling Background"*/}
                                                    {/*    src={currentImage}*/}
                                                    {/*    onClick={handleImageClick}*/}
                                                    {/*    className="block aspect-[10/7] w-full rounded-lg object-cover cursor-pointer"*/}
                                                    {/*/>*/}
                                                    
                                                    <div className="relative flex items-center justify-center"
                                                         onClick={handleContentClick}
                                                    >
                                                        {/* Render current content (image or component) */}
                                                        {typeof currentContent === "string" ? (
                                                            <img src={currentContent} alt={currentKey}
                                                                 className="block aspect-[10/7] w-full rounded-lg object-cover"/>
                                                        ) : (
                                                            <div
                                                                className={`block relative aspect-[10/7] w-full rounded-lg border border-gray-500 overflow-hidden`}>
                                                                <div className={`absolute inset-0`}>
                                                                    {currentContent}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="mt-4 flex items-start justify-between">
                                                        <div>
                                                            <h2 className="text-base font-semibold">
                                                                <span className="sr-only">Background Image</span>Background
                                                                Image: [{currentKey}]
                                                            </h2>
                                                            <p className="text-sm font-medium text-gray-500">Click on
                                                                the image to view choices</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                {/*ToggleSwitch*/}
                                                <div className="w-fit flex items-center mr-10">
                                                    
                                                    <div className={`mr-10 font-medium`}>DarkMode:</div>
                                                    
                                                    <input
                                                        type="checkbox"
                                                        id="spray"
                                                        name="spray"
                                                        checked={darkMode}
                                                        onChange={toggleDarkMode} // Call the toggle function from context
                                                        className="sr-only w-fit"
                                                    />
                                                    <label htmlFor="spray" className="cursor-pointer">
                                                        <div
                                                            className={`mr-auto ml-auto w-14 h-8 rounded-full relative ${darkMode ? 'bg-darkBgColor' : 'bg-bgColor drop-shadow shadow-gray-900'}`}>
                                                            <div
                                                                className={`dot absolute left-1 top-1 w-6 h-6 rounded-full transition-transform duration-300 ${darkMode ? 'bg-darkMainColor translate-x-full animate-rollOut' : 'bg-white animate-rollIn'}`}>
                                                                {darkMode ? (
                                                                    <MoonIcon
                                                                        className="w-4 h-full flex-none text-gray-300 mr-auto ml-auto mt-auto mb-auto"
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : (
                                                                    <SunIcon
                                                                        className="w-4 h-full flex-none text-black mr-auto ml-auto mt-auto mb-auto"
                                                                        aria-hidden="true"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                                
                                                {/*ToggleSwitch*/}
                                                <div className="w-fit flex items-center mr-10">
                                                    
                                                    <div className={`mr-10 font-medium`}>Snowing:</div>
                                                    
                                                    <input
                                                        type="checkbox"
                                                        id="snow"
                                                        name="snow"
                                                        checked={snowing}
                                                        onChange={toggleSnow} // Call the toggle function from context
                                                        className="sr-only w-fit"
                                                    />
                                                    <label htmlFor="snow" className="cursor-pointer">
                                                        <div
                                                            className={`mr-auto ml-auto w-14 h-8 rounded-full relative ${!snowing ? 'bg-blue-400' : 'bg-blue-200 drop-shadow shadow-gray-900'}`}>
                                                            <div
                                                                className={`dot absolute left-1 top-1 w-6 h-6 rounded-full transition-transform duration-300 ${!snowing ? 'bg-white translate-x-full animate-rollOut' : 'bg-white animate-rollIn'}`}>
                                                                {snowing ? (
                                                                    <XMarkIcon
                                                                        className="w-4 h-full flex-none text-black mr-auto ml-auto mt-auto mb-auto"
                                                                        aria-hidden="true"
                                                                    />
                                                                ) : (
                                                                    <CheckIcon
                                                                        className="w-4 h-full flex-none text-black mr-auto ml-auto mt-auto mb-auto"
                                                                        aria-hidden="true"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                                
                                                <div>
                                                    <h3 className="font-medium">Icons Breakdown</h3>
                                                    <dl className="mt-2 divide-y divide-neutral-700 border-b border-t border-neutral-700">
                                                        
                                                        <div className="flex justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <BanknotesIcon className={`size-5 text-red-600 animate-heartbeat`}/>
                                                            </dt>
                                                            <dd className="text-gray-500">No Book Price</dd>
                                                        </div>
                                                        <div className="flex justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <CheckBadgeIcon className={`size-5 text-green-600 animate-heartbeat`}/>
                                                            </dt>
                                                            <dd className="text-gray-500">Early Order</dd>
                                                        </div>
                                                        <div className="flex justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <CreditCardIcon className={`size-5 text-green-600 animate-heartbeat`}/>
                                                            </dt>
                                                            <dd className="text-gray-500">PrePay Order</dd>
                                                        </div>
                                                        <div className="flex justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <PhoneIcon className={`size-5 text-green-600 animate-heartbeat`}/>
                                                            </dt>
                                                            <dd className="text-gray-500">Call Before Delivery</dd>
                                                        </div>
                                                        <div className="flex justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <PencilIcon className={`size-5 text-blue-600`}/>
                                                            </dt>
                                                            <dd className="text-gray-500">Price Edited by Rep</dd>
                                                        </div>
                                                        
                                                        <div className="flex items-center justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <div className={`flex-none rounded-full p-1 bg-cyan-500/30`}>
                                                                    <div className={`size-2 rounded-full bg-cyan-500`}/>
                                                                </div>
                                                            </dt>
                                                            <dd className="text-gray-500">Blank Item</dd>
                                                        </div>
                                                        
                                                        <div className="flex items-center justify-between py-3 text-sm font-medium">
                                                            <dt className="">
                                                                <div className={`flex-none rounded-full p-1 bg-yellow-500/30`}>
                                                                    <div className={`size-2 rounded-full bg-yellow-500`}/>
                                                                </div>
                                                            </dt>
                                                            <dd className="text-gray-500">Contract Price</dd>
                                                        </div>
                                                    
                                                    </dl>
                                                </div>
                                                
                                                <div className="flex">
                                                    <Button
                                                        type="button"
                                                        className="flex-1 rounded-md z-50 bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                        onClick={handleSaveContent}
                                                    >
                                                        Save Preferences
                                                    </Button>
                                                
                                                </div>
                                            </div>
                                        </div>
                                    
                                    </div>
                                
                                
                                </div>
                            </DialogPanel>
                        </div>
                    </div>
                </div>
            </Dialog>
            
            <Dialog open={isLogOut} onClose={setIsLogOut} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-lg border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-600/15 sm:mx-0 sm:size-10">
                                    <ArrowRightStartOnRectangleIcon aria-hidden="true" className="size-6 text-red-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Log out
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            Are you sure you want to LogOut! This will log you out of your account and
                                            redirect you to the Login page!
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <Button
                                    type="button"
                                    onClick={() => {
                                        doSignOut().then(() => {
                                            navigate('/Login');
                                        });
                                    }}
                                    // onClick={() => handleDeleteOrderPlanned(order.customerUID, order.id, order.salesUID)}
                                    className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                >
                                    LogOut
                                </Button>
                                <Button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setIsLogOut(false)}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            
            <Dialog open={chat} onClose={setChat} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform overflow-hidden rounded-lg border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-6xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 sm:mx-0 sm:size-10">
                                    <SparklesIcon aria-hidden="true" className="size-6 text-green-600"/>
                                </div>
                                <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Log out
                                    </DialogTitle>
                                    <div className="mt-2 h-96">
                                        <Chatbot/>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            
            <Dialog open={Happy} onClose={setHappy} className="relative z-50">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />
                
                <FireworksEffect show={true}/>
                
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`animate-epicReveal relative transform overflow-hidden rounded-lg border ${darkMode ? 'bg-darkMainColor text-white border-neutral-700' : 'bg-white text-black'} px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                        >
                            <div className="sm:flex sm:items-start">
                                <div
                                    className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-green-600/15 animate-heartbeat sm:mx-0 sm:size-10">
                                    <CakeIcon aria-hidden="true" className="size-6 text-green-600"/>
                                </div>
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold">
                                        Happy Birthday {fname}!
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            On behalf of everyone at The Plant Food Company, we wish you a day filled
                                            with joy, appreciation, and celebration. We’re grateful for you!
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <Button
                                    type="button"
                                    // onClick={() => {
                                    //     doSignOut().then(() => {
                                    //         navigate('/Login');
                                    //     });
                                    // }}
                                    onClick={dismissBirthdayModal}
                                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 sm:ml-3 sm:w-auto"
                                >
                                    Hide
                                </Button>
                                <Button
                                    type="button"
                                    data-autofocus
                                    onClick={() => setHappy(false)}
                                    className={`mt-3 inline-flex w-full justify-center rounded-md ${darkMode ? 'bg-darkBgColor' : 'bg-white ring-1 ring-inset ring-gray-300'} px-3 py-2 text-sm font-semibold shadow-sm hover:bg-opacity-50 sm:mt-0 sm:w-auto`}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            
        </>
    )
}

export default Content;
